import { loadState, saveState } from './storage'

const redirectKey = 'redirect'
const redirectStorage = true

export const setRedirectPath = (path: string) => saveState(path, redirectStorage, redirectKey)
export const getRedirectPath = () => {
  const state = loadState(redirectStorage, redirectKey, '')
  return typeof state === 'string' ? state : ''
}

const type = process.env.REACT_APP_TYPE
export const getOrderRedirectPath = () => {
  return (type === 'mm' || type === 'box') ? '/map' : '/home'
}
